import React, {useState} from 'react';
import { Link } from 'react-router-dom';
import SideBar from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";
import { CopyBlock, dracula } from "react-code-blocks";
import textExample4 from './assets/images/text-example4.png';


const CSSLesson22 = () => {


  const [language, changeLanguage] = useState("css");
  const [lineNumbers, toggleLineNumbers] = useState(false);
  const code = (
  'text',
  `
   p.uppercase {
    text-transform: uppercase;
   }
   p.uppercase {
    text-transform: lowercase;
   }
   p.capitalize {
    text-transform: capitalize;
   }

  `
  );
  const code1 = (
  'text',
  `
   div {
    text-align: justify;
   }

  `
  );
  const code2 = (
  'text',
  `
   a {
    text-decoration: none;
   }

  `
  );

  const code3 = (
    'text',
    `
     p.uppercase {
      text-transform: uppercase;
     }
     p.uppercase {
      text-transform: lowercase;
     }
     p.capitalize {
      text-transform: capitalize;
     }
  
    `
    );

    const code4 = (
      'text',
      `
       p {
        direction: rtl;
       }
    
      `
      );
    const code5 = (
      'text',
      `
       div.a {
        text-indent: 45px;
       }
       div.b {
        text-indent: 2em;
       }

       div.b {
        text-indent: 30%;
       }
    
      `
      );
  return (
    <HTMLCourseNavProvider>
      <div className="container">
        <div className="row">
          <div>
            <SideBar />
          </div>
          

          <div className="alert alert-secondary" role="alert">
          <h3><strong>Text Color</strong></h3>    
<p>The color property is used to set the color of the text. The color is specified by:</p>
<ol class="list-group list-group-numbered mb-4">
  <li class="list-group-item">a color name - like "red"</li>
  <li class="list-group-item">a HEX value - like "#ff0000"</li>
  <li class="list-group-item">an RGB value - like "rgb(255,0,0)"</li>
</ol>
<CopyBlock
    language={"css"}
    text={code}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
   </div>


   <div className="alert alert-secondary" role="alert">
<h3><strong>Text Alignment</strong></h3>    
<p>The <b class="text-danger">text-align</b> property is used to set the horizontal alignment of a text.</p>
<p>A text can be <b class="text-danger">left</b> or <b class="text-danger">right</b> aligned, <b class="text-danger">centered</b>, or <b class="text-danger">justified</b>.</p>
<p>When the text-align property is set to "justify", each line is stretched so that every line has equal width, and the left and right margins are straight (like in magazines and newspapers):</p>
 

<CopyBlock
    language={"css"}
    text={code1}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    </div>
    
    <div className="alert alert-secondary" role="alert">
<h3><strong>Text Decoration</strong></h3>    
<p>The text-decoration property is used to set or remove decorations from text.</p>
<p>The value text-decoration: none; is often used to remove underlines from links</p>

<CopyBlock
    language={"css"}
    text={code2}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />

    </div>

    <div className="alert alert-secondary" role="alert">

<h3><strong>Text Transformation</strong></h3>
<p>The <b class="text-danger">text-transform</b> property is used to specify uppercase and lowercase letters in a text</p>
<p>It can be used to turn everything into uppercase or lowercase letters, or capitalize the first letter of each word.</p>

<CopyBlock
    language={"css"}
    text={code3}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    </div>

    <div className="alert alert-secondary" role="alert">
<h3><strong>Text Direction</strong></h3>
<p>The direction property is used to change the text direction of an element</p>

<CopyBlock
    language={"css"}
    text={code4}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    /><p>The direction property in CSS sets the direction of of content flow within a block-level element. This applies to text, inline, and inline-block elements. It also sets the default alignment of text and the direction that table cells flow within a table row.</p>
<p>The valid values are:</p>
<ol>
<li>ltr &mdash; Left to Right, the default</li>
<li>rtl &mdash; Right to Left</li>
<li>inherit &mdash; inherits its value from the parent element</li>
</ol>
</div>
  

<div className="alert alert-secondary" role="alert">
<h3><strong>Text Indentation</strong></h3>
<p>The <b class="text-danger">text-indent</b> property specifies the indentation of the first line in a text-block.</p>
<p>Negative values can also be used. The first line will be indented to the left if the value is negative.</p>

<CopyBlock
    language={"css"}
    text={code5}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    </div>

          
                </div>
        </div>
    </HTMLCourseNavProvider>
  );
};

export default CSSLesson22;
